import http from "./http";

function getFlags(params) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .get(`${api}/flags`, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
        params: {
          ...params,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function putFlag(flagId, flag) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .put(`${api}/flags/${flagId}`, flag, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function postFlag(flag) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .post(`${api}/flags`, flag, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

export default {
  getFlags,
  putFlag,
  postFlag,
};
